import { render, staticRenderFns } from "./DevicesStatisticsByCategoryCard.vue?vue&type=template&id=54ff802d"
import script from "./DevicesStatisticsByCategoryCard.vue?vue&type=script&lang=js"
export * from "./DevicesStatisticsByCategoryCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports